import axios from 'axios';

// search vat input api
export async function searchPaymentMethodAPI(Data) {
	let pmlist = [];
	const pmVal = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/paymentMethod/search/?pmName=${pmVal}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		pmlist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return pmlist;
}

// check existing vat input api
export async function getPaymentMethodAPI(Data) {
	let pmlist = [];
	const pmName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/paymentMethod/getpm/?pmName=${pmName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		pmlist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return pmlist;
}

//create status api
export async function createPaymentMethodAPI(Data, userID) {
	let pmData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/paymentMethod/create/`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		pmData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return pmData;
}

//update status api
export async function updatePaymentMethodAPI(Data, pmID, userID) {
	let pmData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/paymentMethod/update/?pmID=${pmID}&userID=${userID}`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		pmData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return pmData;
}